import React from 'react'
import classes from './Form.scss'
import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'

const form = ({ form, inputChanged }) => {
  let tabContent = null
  tabContent = Object.entries(form).map(res => {
    let [key, attr] = res

    if (key === 'is_threshold' && attr.disabled) {
      return null
    } else if (key === 'is_unlimited' && attr.disabled) {
      return null
    } else if (key === 'is_get_zero' && attr.disabled) {
      return null
    } else {
      return (
        <InputGroup
          key={key}
          label={attr.label}
          inputType={attr.elementType}
          configs={attr.elementConfig}
          invalid={!attr.valid}
          validations={attr.validation}
          touched={attr.touched}
          changed={e => inputChanged(key, e)}
          inputValue={attr.value}
          validationError={attr.error}
        />
      )
    }
  })

  return <div className={classes.Form}>{tabContent}</div>
}

export default form
